export const PROMO_BANNER_THEMES = {
  WARNING: 'warning',
  GRADIENT: 'gradient',
}
